<template>
  <div class="page-container">
    <div class="loader" v-if="loader">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>

    <div class="text-color border-color background-color card" style="position: relative" v-if="!loader">
      <div>
        <h3 class="ps-title-bar">
          آدرس جایگاه های پمپ بنزین
          <img src="../../assets/img/location-center.png" />
        </h3>
        <div class="text-box">
          برای مسیریابی، جایگاه سوخت موردنظر را انتخاب کنید.
        </div>

        <h3 class="ps-title-bar" v-if="errorCode == 1">
          {{ this.errorMessage }}
        </h3>

        <div class="select-location-content">
          <div class="map-container" id="selectLoationMap"></div>
          <div id="current-loc-btn">
            <a v-on:click="goToPersonLocation()"><img src="../../assets/img/current_loc.png" /></a>
          </div>
          <div id="modal-data" v-if="selectedItem">
            <div>
              <a target="_blank" :href="goToGeo">
                <img src="../../assets/img/location.jpg" />
              </a>
            </div>

            <div class="address">
              <div class="title">
                {{ selectedItem.Title }}
              </div>
              <div class="detail">
                {{ selectedItem.Address }}
              </div>
              <hr />
              <div v-if="selectedItem.PhoneNumber" class="phone">
                <div class="phone-title">
                  <i class="fas fa-phone"></i> تلفن:
                </div>
                <div>{{ selectedItem.PhoneNumber }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="error-message" v-if="!loader && errorMessage">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import api from "../../service";
import { mapActions } from "vuex";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// import MainModal from "/Users/jawadabbasnia/Documents/iranecar-app/IraneCarApp.PWA/core/src/components/MainModal.vue";

var LeafIcon = L.Icon.extend({
  options: {
    iconSize: [38, 38],
    shadowSize: [50, 64],
    iconAnchor: [22, 94],
    shadowAnchor: [4, 62],
    popupAnchor: [-3, -76],
  },
});

export default {
  name: "petrol-stations",
  props: {},
  //  components: {
  //           MainModal,
  //       },
  data() {
    return {
      longitude: null,
      latitude: null,
      userLongitude: null,
      userLatitude: null,
      errorMessage: null,
      errorCode: null,
      loader: false,
      items: [],
      selectedItem: null,
      NameFlag: false,
      EmailFlag: false,
      CodeFlag: false,
    };
  },
  mounted: function () {
    if (this.$route.query.theme == "dark") {
      this.setTheme("dark");
    }
    if (this.$route.query.token) {
      this.setToken(this.$route.query.token);
    }
    if (this.$route.query.longitude && this.$route.query.latitude) {
      this.userLatitude = this.$route.query.latitude;
      this.userLongitude = this.$route.query.longitude;
    }

    this.mapInit();
    this.loading = true;
  },
  computed: {
    goToGeo() {
      let url = "";
      if (this.selectedItem != {}) {
        const userAgent =
          navigator.userAgent || navigator.vendor || window.opera;
        const {
          Latitude: lat,
          Longitude: long,
          Title: title,
        } = this.selectedItem;
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          url = `maps://maps.google.com/maps?daddr=${lat}, ${long};ll=`;
        } else if (/android/i.test(userAgent)) {
          url = `geo:${lat},${lat}?q=${lat},${long}(${title})`;
        } else {
          url = `https://maps.google.com/?ll=${lat}, ${long}`;
        }
      }

      return url;
    },
  },
  methods: {
    ...mapActions(["setTheme", "setToken"]),

    loadMapData() {
      api
        .getPetrolStations({
          longitude: this.longitude,
          latitude: this.latitude,
        })
        .then((response) => {
          if (response.data && response.data.Status === 200) {
            this.items = response.data.Data;

            for (let i = 0; i < this.items.length; i++) {
              const element = this.items[i];

              const ico = new LeafIcon({
                iconUrl: require("@/assets/img/map-pin.png"),
                iconSize: [30, 30],
                iconAnchor: [15, 15],
                draggable: false,
              });

              this.marker = L.marker([element.Latitude, element.Longitude], {
                icon: ico,
                element,
              })
                .addTo(this.map)
                //.bindPopup("<div class='address'><div class='title'>" +  element.Title + "</div><div class='detail'>" + element.Address + "</div><hr /><div class='phone'><div class='phone-title'><i class='fas fa-phone'></i> تلفن: </div><div>" + element.PhoneNumber + "</div></div></div>")
                .on("click", (e) => {
                  const el = JSON.parse(
                    JSON.stringify(e.target.options.element)
                  );
                  this.selectedItem = el;
                  return false;
                });
            }
          } else {
            if (
              response.data &&
              response.data.Messages &&
              response.data.Messages.length > 0
            ) {
              this.errorMessage = response.data.Messages[0];
            }
          }
        })
        .catch(() => {
          this.errorMessage = "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
        })
        .finally(() => {
          this.loading = false;
        });
    },

    showModal(type) {
      if (type == "NameFlag") {
        this.NameFlag = true;
      } else if (type == "EmailFlag") {
        this.EmailFlag = true;
      } else if (type == "CodeFlag") {
        this.CodeFlag = true;
      }
    },
    closeModal(type) {
      if (type == "NameFlag") {
        this.NameFlag = false;
      } else if (type == "EmailFlag") {
        this.EmailFlag = false;
      } else if (type == "CodeFlag") {
        this.CodeFlag = false;
      }
    },
    mapInit() {
      const mapOptions = {
        center: [this.userLatitude || 35.6892, this.userLongitude || 51.389],
        zoom: 15,
        maxZoom: 19,
        minZoom: 5,
        attributionControl: false,
        zoomControl: false,
      };
      this.map = L.map("selectLoationMap", mapOptions);

      L.tileLayer(
        "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=sk.eyJ1IjoiYmFtYW5jbHViIiwiYSI6ImNrazJoMHUwaTExZDEybnBjbWhoY3F0anIifQ.ehyogHeVOGNKzunub9Aa8A"
      ).addTo(this.map);

      this.goToPersonLocation();

      this.map.on("move", () => {
        // this.marker.setLatLng(this.map.getCenter());
      });

      this.map.on("dragend", (e) => {
        this.selectedPosition = e.target.getCenter();

        this.latitude = e.target.getCenter().lat;
        this.longitude = e.target.getCenter().lng;
        this.loadMapData();
      });
    },
    setCoordinate(lat, long) {
      this.longitude = long;
      this.latitude = lat;
    },
    onclickTest() {
      console.log("clicked test");
    },
    goToPersonLocation() {
      var options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      };
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.setCoordinate(pos.coords.latitude, pos.coords.longitude);
          this.map.setView(
            new L.LatLng(pos.coords.latitude, pos.coords.longitude)
          );
          if (this.userMarker) {
            this.map.removeLayer(this.userMarker);
          }
          this.userMarker = L.marker(
            [pos.coords.latitude, pos.coords.longitude],
            {
              icon: new LeafIcon({
                className: "signals",
                iconUrl: require("@/assets/img/current-location.svg"),
                iconSize: [25, 25],
                iconAnchor: [9, 9],
              }),
            }
          );
          this.map.addLayer(this.userMarker);

          this.latitude = pos.coords.latitude;
          this.longitude = pos.coords.longitude;
          this.loadMapData();
        },
        (err) => {
          if (err.code === 1) {
            this.errorCode = err.code;
            this.errorMessage =
              "لطفا لوکیشن دستگاه خود را فعال و صفحه را رفرش کنید.";
          }
          //   this.errorMessage = err.code;
        },
        options
      );
    },
  },
};
</script>

<style scoped>
.signals {
  width: 30px;
  height: 30px;
  animation-name: signal;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-direction: normal;
  animation-fill-mode: both;
}

@keyframes signal {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.img-header {
  width: 65px;
  border: 1px solid;
  padding: 11px;
  border-radius: 50%;
  height: 65px;
  z-index: 100;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
}

.card {
  border: solid 1px;
  padding: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100vh;
}

.ps-title-bar {
  text-align: center;
  height: 46px;
  align-items: center;
  justify-content: center;
  display: flex;
}

.ps-title-bar>img {
  width: 24px;
  margin-right: 5px;
}

.select-location-container {
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: 10000;
  overflow: scroll;
  margin: 0 -15px;
}

.select-location-content {
  background-color: white;
  position: relative;
}

.map-container {
  width: 100%;
  height: calc(100vh - 98px);
}

#modal-data {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: 40px;
  background-color: white;
  border: solid 1px silver;
  border-radius: 7px;
  padding: 2px;
  z-index: 100000;
  display: flex;
}

#modal-data-2 {}

#current-loc-btn {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: 150px;
  background-color: white;
  border: solid 1px silver;
  border-radius: 7px;
  align-content: center;
  padding: 12px;
  z-index: 100000;
  height: 55px;
  width: 55px;
}

#current-loc-btn img {
  width: 100%;
  height: auto;
}

#modal-data>div {
  padding: 5px;
}

.leaflet-popup {
  margin-bottom: -40px !important;
}

.address {
  min-width: 160px;
  direction: rtl;
  text-align: right;
  line-height: 24px;
  width: 100%;
}

.currentloc {
  min-width: 160px;
  direction: rtl;
  text-align: right;
  line-height: 24px;
  width: 100%;
}

.address .title {
  font-weight: bold;
}

.address .detail {
  color: #888;
}

.address hr {
  margin: 5px 0;
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  padding: 0;
}

.address .phone {
  display: flex;
  align-items: center;
}

.address .phone i {
  color: white;
  border-radius: 50%;
  background-color: #222;
  padding: 4px;
  margin-left: 4px;
  font-size: 9px;
}

.address .phone-title {
  flex: 1;
}

.text-box {
  text-align: center;
  background: #002664;
  color: #fff;
  padding: 10px;
}
</style>
